// --- Product Page Logic ---

// 1. Image Gallery
function updateMainImage(src, thumb) {
    const mainImg = document.getElementById('main-prod-img');
    if (!mainImg) return;
    mainImg.style.opacity = '0';
    setTimeout(() => {
        mainImg.src = src;
        mainImg.style.opacity = '1';
    }, 200);

    // Update active thumb
    if (thumb) {
        document.querySelectorAll('.thumb, .thumb-item').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
    }
}

// 2. Bundle Selection
function selectBundle(id, price, oldPrice, element) {
    // Update UI selection
    document.querySelectorAll('.bundle-card').forEach(c => c.classList.remove('active'));
    element.classList.add('active');

    // Update main price display
    const priceDisplay = document.getElementById('display-price');
    const oldPriceDisplay = document.getElementById('display-old-price');

    if (priceDisplay) priceDisplay.innerText = `Tk ${price.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
    if (oldPriceDisplay) oldPriceDisplay.innerText = `Tk ${oldPrice.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
}

// 3. Flash Sale Timer
function startTimer() {
    const hoursEl = document.getElementById('hours');
    const minEl = document.getElementById('minutes');
    const secEl = document.getElementById('seconds');
    const endDateEl = document.getElementById('end-date');

    const now = new Date();
    const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

    const options = { month: 'long', day: 'numeric' };
    if (endDateEl) endDateEl.innerText = endDate.toLocaleDateString('en-US', options);

    function update() {
        const currentTime = new Date();
        const diff = endDate - currentTime;

        if (diff <= 0) {
            clearInterval(timerInterval);
            return;
        }

        const h = Math.floor(diff / (1000 * 60 * 60));
        const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((diff % (1000 * 60)) / 1000);

        if (hoursEl) hoursEl.innerText = h.toString().padStart(2, '0');
        if (minEl) minEl.innerText = m.toString().padStart(2, '0');
        if (secEl) secEl.innerText = s.toString().padStart(2, '0');
    }

    const timerInterval = setInterval(update, 1000);
    update();
}

// 4. Global DOM Content Loaded
document.addEventListener('DOMContentLoaded', () => {
    // FAQ Accordion
    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(q => {
        q.addEventListener('click', () => {
            const item = q.parentElement;
            const isActive = item.classList.contains('active');
            document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));
            document.querySelectorAll('.faq-question span').forEach(s => {
                s.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
            });
            if (!isActive) {
                item.classList.add('active');
                q.querySelector('span').innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3"><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
            }
        });
    });

    startTimer();

    // Swiper Initialization for Thumbnails
    if (document.querySelector('.thumbnail-slider')) {
        const swiper = new Swiper('.thumbnail-slider', {
            slidesPerView: 5,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                320: { slidesPerView: 3, spaceBetween: 5 },
                768: { slidesPerView: 4, spaceBetween: 10 },
                1024: { slidesPerView: 5, spaceBetween: 10 }
            }
        });
    }

    // Thumbnail Click Handling
    const thumbs = document.querySelectorAll('.thumb, .thumb-item');
    thumbs.forEach(thumb => {
        thumb.addEventListener('click', function() {
            // Support both direct img tags (homepage) and div containers (product page)
            const img = this.tagName === 'IMG' ? this : this.querySelector('img');
            if (img) {
                updateMainImage(img.getAttribute('src'), this);
            }
        });
    });

    // Lightbox Functionality
    const mainProdImg = document.getElementById('main-prod-img');
    const lightbox = document.getElementById('lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    const closeLightbox = document.querySelector('.close-lightbox');

    if (mainProdImg && lightbox && lightboxImg) {
        mainProdImg.addEventListener('click', () => {
            lightbox.classList.add('active');
            lightboxImg.src = mainProdImg.src;
            document.body.style.overflow = 'hidden'; // Stop scrolling
        });

        closeLightbox.addEventListener('click', () => {
            lightbox.classList.remove('active');
            document.body.style.overflow = ''; // Resume scrolling
        });

        lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox) {
                lightbox.classList.remove('active');
                document.body.style.overflow = '';
            }
        });
    }

    // Scroll Animations
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('appear');
            }
        });
    }, { threshold: 0.1 });

    document.querySelectorAll('section').forEach(section => {
        section.classList.add('fade-in-up');
        observer.observe(section);
    });

    // --- Mobile Menu Toggle ---
    const menuOpenBtn = document.getElementById('menu-open-btn');
    const menuCloseBtn = document.getElementById('menu-close-btn');
    const mobileNav = document.getElementById('mobile-nav');
    const navOverlay = document.getElementById('nav-overlay');

    if (menuOpenBtn && mobileNav && navOverlay) {
        const toggleMenu = (show) => {
            mobileNav.classList.toggle('active', show);
            navOverlay.classList.toggle('active', show);
            document.body.classList.toggle('no-scroll', show);
        };

        menuOpenBtn.addEventListener('click', () => toggleMenu(true));
        
        if (menuCloseBtn) {
            menuCloseBtn.addEventListener('click', () => toggleMenu(false));
        }
        
        navOverlay.addEventListener('click', () => toggleMenu(false));
    }
});
